// Work queues — who picks what (owner 2026-11-01: some operators get some orders and others the
// rest; today Visma and the webshop hand them separate lists, told apart by a field on the order).
// A queue is a name and a rule in the flow guard language over the order's fields; the rules are
// checked top-down, the first match places the order, the default queue takes the rest. Users and
// devices subscribe to queues; a lead may see every queue. Company-level configuration.
import { z } from "zod";
import { evaluateBoolean } from "../flows/expr.js";
export const PickQueue = z.object({
    /** Shown on the phone and in Utleverans; the key the subscriptions use. */
    name: z.string().trim().min(1).max(40),
    /** Guard expression over the order; empty on the default queue. */
    rule: z.string().max(1000).default(""),
    /** Exactly one queue should be the default; the first one marked wins. */
    default: z.boolean().default(false),
});
/** The queue an order belongs to, or null when no queues are configured. A rule that throws
 *  counts as not matching (the editor warns at save). */
export function resolveQueue(queues, order) {
    if (queues.length === 0)
        return null;
    const ctx = { source: order.source, reference: order.reference, carrier: order.carrier, deliveryDate: order.deliveryDate, customer: order.customer ? { key: order.customer.key, name: order.customer.name } : null, external: order.external ?? {}, lines: order.lines.map((l) => ({ sku: l.sku, quantity: Number(l.quantity), uom: l.uom })), lineCount: order.lines.length };
    for (const q of queues) {
        if (q.default || !q.rule.trim())
            continue;
        try {
            if (evaluateBoolean(q.rule, ctx))
                return q.name;
        }
        catch { /* a broken rule never matches */ }
    }
    return queues.find((q) => q.default)?.name ?? queues.find((q) => !q.rule.trim())?.name ?? null;
}
/** Problems with a queue list: a rule that does not parse, two default queues, duplicate names. */
export function checkQueues(queues) {
    const out = [];
    const names = new Set();
    for (const q of queues) {
        if (names.has(q.name.toLowerCase()))
            out.push(`Kön "${q.name}" finns två gånger`);
        names.add(q.name.toLowerCase());
        if (q.rule.trim()) {
            try {
                evaluateBoolean(q.rule, { external: {}, lines: [] });
            }
            catch (e) {
                out.push(`"${q.name}": ${e instanceof Error ? e.message : String(e)}`);
            }
        }
    }
    if (queues.filter((q) => q.default).length > 1)
        out.push("Bara en kö kan vara standard");
    if (queues.length > 0 && !queues.some((q) => q.default || !q.rule.trim()))
        out.push("Ingen standardkö: ordrar som ingen regel träffar hamnar utanför alla köer");
    return out;
}
//# sourceMappingURL=queues.js.map